import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { catalogTypeClean, cleanSearchingCatalogTypesPaginated } from "../../app/actions/catalogTypeActions";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsCatalogTypes = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewCatalogTypes", event: "NewCatalogTypes-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListCatalogTypes", event: "ListCatalogTypes-Clicked" });
      dispatch(cleanSearchingCatalogTypesPaginated())
    }

    dispatch(catalogTypeClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCatalogTypes" && (
        <Link
          data-tip
          data-for="newCatalogTypesTip"
          to="/admin-catalog-type/new-catalog-type"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCatalogTypes" && (
        <Link
          data-tip
          data-for="listCatalogTypesTip"
          to="/admin-catalog-type/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCatalogTypes" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCatalogTypesTip"
            to="/admin-catalog-type/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCatalogTypesTip"
            to="/admin-catalog-type/new-catalog-type"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCatalogTypesTip" place="left" effect="solid">
        {t("admin-catalog-type.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCatalogTypesTip" place="left" effect="solid">
        {t("admin-catalog-type.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCatalogTypes;
